module.exports = __webpack_public_path__ + "img/pic1.892042e0.jpg";